<template>
  <loader v-if="fetchUserProfilePending"/>
  <v-container v-else>
    <v-row>
      <v-col :cols="12">
        <h1>{{ $t('texts.userData') }}</h1>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-card>
          <v-card-text class="pa-5">
            <form>
              <v-container class="pa-0">
                <v-row>
                  <v-col>
                    <v-autocomplete
                      :items="salutationItems"
                      v-model="userData.sex"
                      :label="$t('texts.salutation')"
                      item-text="text"
                      item-value="value"
                      required
                      :error-messages="errors.collect('salutation')"
                      v-validate="'required'"
                      data-vv-name="salutation"
                      :data-vv-as="$t('texts.salutation')"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-text-field
                      name="userFirstName"
                      :label="$t('texts.firstName')"
                      value=""
                      v-model="userData.first_name"
                      required
                      :error-messages="errors.collect('firstName')"
                      v-validate="'required'"
                      data-vv-name="firstName"
                      :data-vv-as="$t('texts.firstName')"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-text-field
                      name="userLastName"
                      :label="$t('texts.lastName')"
                      value=""
                      v-model="userData.last_name"
                      required
                      :error-messages="errors.collect('lastName')"
                      v-validate="'required'"
                      data-vv-name="lastName"
                      :data-vv-as="$t('texts.lastName')"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-text-field
                      name="employeeEmail"
                      :label="$t('texts.email')"
                      value=""
                      v-model="userData.email"
                      required
                      :error-messages="errors.collect('email')"
                      v-validate="'required|email'"
                      data-vv-name="email"
                      :data-vv-as="$t('texts.email')"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-autocomplete
                      :items="select.language"
                      v-model="userData.language"
                      :label="$tc('texts.language.label', 1)"
                      item-text="langName"
                      item-value="langKey"
                      required
                      :error-messages="errors.collect('language')"
                      v-validate="'required'"
                      data-vv-name="language"
                      :data-vv-as="$tc('texts.language.label', 1)"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-checkbox
                      v-model="userData.newsletter"
                      :label="$t('texts.acceptAdvertising')"
                      :true-value="true"
                      :false-value="false"
                      color="primary"
                      hide-details
                      class="mt-0"
                    />
                  </v-col>
                </v-row>
              </v-container>
            </form>
          </v-card-text>
          <v-divider/>
          <v-card-actions class="py-3 px-5">
            <v-spacer/>
            <v-btn
              color="primary"
              class="white--text"
              @click.stop.prevent="updateProfile()"
              :disabled="updateUserProfilePending"
              :loading="updateUserProfilePending"
            >
              {{ $t('texts.save') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const { mapState: mapUserState, mapActions: mapUserActions } = createNamespacedHelpers('user');
const { mapActions: mapMessageActions } = createNamespacedHelpers('messages');

export default {
  name: 'UserProfileGeneral',
  data() {
    return {
      userData: {
        sex: null,
        first_name: '',
        last_name: '',
        email: '',
        language: '',
        newsletter: false,
      },
      select: {
        language: [
          { langKey: 'de', langName: 'Deutsch' },
          { langKey: 'it', langName: 'Italiano' },
          { langKey: 'en', langName: 'English' },
        ],
      },
    };
  },
  $_veeValidate: {
    validator: 'new',
  },
  created() {
    this.fetchUserProfile().then(() => {
      Object.assign(this.userData, this.authUser);
    });
  },
  computed: {
    ...mapUserState([
      'authUser',
      'language',
      'fetchUserProfilePending',
      'updateUserProfilePending',
    ]),
    salutationItems() {
      const items = [
        { value: 1, text: this.$i18n.t('texts.salutationMr') },
        { value: 2, text: this.$i18n.t('texts.salutationMrs') },
      ];
      return items;
    },
  },
  methods: {
    ...mapUserActions([
      'fetchUserProfile',
      'updateUserProfile',
    ]),
    ...mapMessageActions([
      'showMessage',
      'showMessageValidateError',
    ]),
    updateProfile() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.updateUserProfile(this.userData);
        } else {
          this.showMessageValidateError();
        }
      });
    },
  },
};
</script>
